import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface AppConfig {
  appTitle: string;
  defaultLanguage: string;
  logoPath: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: AppConfig = {
    appTitle: 'Admin',
    defaultLanguage: 'fr',
    logoPath: 'assets/img/brand/LOGO.png',
  };

  private configLoaded = false;

  constructor(private readonly http: HttpClient) {}

  async loadConfig(): Promise<void> {
    try {
      const data = await firstValueFrom(
        this.http.get<AppConfig>('/assets/config.json'),
      );
      this.config = { ...this.config, ...data };
      this.configLoaded = true;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_error) {
      this.configLoaded = true;
    }
  }

  get(key: keyof AppConfig) {
    if (!this.configLoaded) {
      return this.config[key];
    }
    return this.config[key];
  }

  isConfigLoaded(): boolean {
    return this.configLoaded;
  }
}
